var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowSmallCurveLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.289,
    height: 13.929,
    viewBox: "0 0 136.289 13.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42170",
    "data-name": "Path 42170",
    d: "M0,5.719S36.462-4.349,68.411-3.669s43.8,7.814,67.7,11.457c-4.935.748-33.772-5.14-67.8-5.657S0,5.719,0,5.719Z",
    transform: "matrix(1, -0.017, 0.017, 1, 0.065, 6.077)",
    fill: "#ffce00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowSmallCurveLine);
export default __webpack_public_path__ + "static/media/yellowSmallCurveLine.a700713da134f44a8c80161cb97ffe93.svg";
export { ForwardRef as ReactComponent };